module.exports = "/static/assets/646ab9a5cb16c06fc4981589db2e44a7.png";